import { z } from 'zod/v4'
import { listResourceSchema } from '@/types/schema/api/list-resource-schema'

export interface FetchCampaignContractTemplateListRequest {
  campaignId: number
  page: number
  campaign_kol_id: number
}

const campaignContractTemplateSchema = z.object({
  id: z.number(),
  content: z.string(),
  title: z.string(),
})

export const fetchCampaignContractTemplateListResponseSchema =
  listResourceSchema.extend({
    data: campaignContractTemplateSchema.array(),
  })
export type FetchCampaignContractTemplateListResponse = z.infer<
  typeof fetchCampaignContractTemplateListResponseSchema
>
